import React from 'react';
import PropTypes from 'prop-types';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import Text from "react-native-web/dist/exports/Text";
import { useThemeTokens } from '../ThemeProvider';
import Icon from '../Icon';
import Spacer from '../Spacer';
import { useListboxContext } from './ListboxContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = StyleSheet.create({
  controlWrapper: {
    width: '100%',
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    boxSizing: 'border-box'
  }
});
const GroupControl = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    expanded,
    pressed,
    hover,
    focus,
    label,
    id
  } = _ref;
  const {
    selectedId,
    setSelectedId
  } = useListboxContext();
  const tokens = useThemeTokens('Listbox', {}, {}, {
    expanded,
    pressed,
    hover,
    current: selectedId === id && id !== undefined,
    focus
  });
  const {
    groupFontName,
    groupFontWeight,
    groupFontSize,
    groupColor,
    groupBackgroundColor,
    groupBorderColor,
    groupBorderWidth,
    groupBorderRadius,
    groupPaddingLeft,
    groupPaddingRight,
    groupPaddingTop,
    groupPaddingBottom,
    itemTextDecoration,
    itemOutline,
    groupHeight
  } = tokens;
  const getTextStyles = () => ({
    color: groupColor
  });
  return /*#__PURE__*/_jsxs(View, {
    onPress: () => setSelectedId(id),
    style: [styles.controlWrapper, {
      fontFamily: `${groupFontName}${groupFontWeight}normal`,
      fontSize: groupFontSize,
      color: groupColor,
      textDecoration: itemTextDecoration,
      backgroundColor: groupBackgroundColor,
      outline: itemOutline,
      height: groupHeight,
      border: `${groupBorderWidth}px solid ${groupBorderColor}`,
      borderRadius: groupBorderRadius,
      paddingLeft: groupPaddingLeft - groupBorderWidth,
      paddingRight: groupPaddingRight - groupBorderWidth,
      paddingTop: groupPaddingTop - groupBorderWidth,
      paddingBottom: groupPaddingBottom - groupBorderWidth
    }],
    ref: ref,
    children: [/*#__PURE__*/_jsx(Text, {
      style: getTextStyles(),
      children: label
    }), /*#__PURE__*/_jsx(Spacer, {
      space: 1,
      direction: "row"
    }), /*#__PURE__*/_jsx(Icon, {
      icon: tokens.groupIcon,
      tokens: {
        color: tokens.groupColor
      },
      variant: {
        size: 'micro'
      }
    })]
  });
});
GroupControl.displayName = 'GroupControl';
GroupControl.propTypes = {
  id: PropTypes.string,
  expanded: PropTypes.bool,
  pressed: PropTypes.bool,
  hover: PropTypes.bool,
  focus: PropTypes.bool,
  label: PropTypes.string
};
export default GroupControl;